// extracted by mini-css-extract-plugin
module.exports = {"container":"TradingViewWidget_container__3C2rk","preview":"TradingViewWidget_preview__yyn9b"};